import Loadable from '~/utils/loadable'

export default Loadable({
  loader: () => import('./Router'),
  loading: () => null,
})
